import React from "react";
import styles from "./LoadingScreen.module.scss";

const STORE_BADGES = [
  {
    label: "Google Play",
    url: "https://play.google.com/store/apps/details?id=com.appcargo.user",
    img: "/stores/btn_google.svg",
  },
  {
    label: "App Store",
    url: "https://apps.apple.com/us/app/car-go-anywhere/id999970383",
    img: "/stores/btn_apple.svg",
  },
  {
    label: "Huawei AppGallery",
    url: "https://appgallery.huawei.com/#/app/C103244763?channelId=EURSMKT20210219CG&detailType=0",
    img: "/stores/btn_huawei.svg",
  },
];

function LoadingScreen() {
  return (
    <div className={styles.loadingScreen}>
      <div className={styles.glowOrbTop} />
      <div className={styles.glowOrbBottom} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img className={styles.logo} src="/logo_app.svg" alt="CAR:GO" />
        </div>

        <h1 className={styles.title}>CAR:GO</h1>
        <p className={styles.subtitle}>Preparing your ride...</p>

        <div className={styles.progressTrack}>
          <div className={styles.progressBar} />
        </div>

        <p className={styles.divider}>Or download the app</p>

        <div className={styles.stores}>
          {STORE_BADGES.map((store) => (
            <a
              key={store.label}
              className={styles.storeLink}
              href={store.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={store.label}>
              <img className={styles.storeImg} src={store.img} alt={store.label} />
            </a>
          ))}
        </div>
      </div>

      <a className={styles.footerLink} href="https://appcargo.com">
        appcargo.com
      </a>
    </div>
  );
}

export default LoadingScreen;
